export const environment = {
    production: true,
    env: 'production',
    apiUrl: 'https://api.prod.kwils.h6.run/api/',
    whitelistedDomains: ['api.prod.kwils.h6.run'],
    blacklistedRoutes: [],
};
